/* eslint-disable */
import { Routes, Route } from 'react-router-dom';
import { useMatch } from 'react-router-dom';
import { OrganizerTrips } from '../host';
import CustomHeader from '../host/components/orgHeader/CustomHeader';
import TripDetails from '../host/pages/tripDetails/TripDetails';
import { getOrganizerInfo } from '../host/fetchData';
import { useOrganizer } from '../host/context/OrganizerContext';
import CustomFooter from '../host/components/orgFooter/CustomFooter';
import ReviewBooking from '../host/pages/reviewBooking/ReviewBooking';
import { BookingDataProvider } from '../host/context/BookingDataContext';
import VerifyPayment from '../host/components/payment/verifyPayment';
import BookingConfirmation from '../host/pages/bookingConfirmation/bookingConfirmation';
import { useEffect, useState } from 'react';
import ScrollToTop from '../components/scrollTop/ScrollTop';

export default function HostLayout() {
    const match = useMatch('/h/orgid/:id');

    const id = match?.params?.id;
    const isOrgId = Boolean(match);
    const { organizer, saveOrganizer, searchValue, setSearchValue } = useOrganizer();
    const [type, setType] = useState('trip');
    const [loading, setLoading] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [debounceSearch, setDebounceSearch] = useState('');

    useEffect(() => {
        if (!id) return;
        getOrganizerInfo(type, id, saveOrganizer, setLoading);
    }, [id]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 450) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!organizer?._id) return;

        const channel = new BroadcastChannel('org_channel');
        channel.postMessage({ type: 'UPDATE_ORG', payload: organizer });

        return () => channel.close();
    }, [organizer]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (debounceSearch.length >= 3) {
                setSearchValue(debounceSearch);
            } else {
                setSearchValue('');
            }
        }, 100);

        return () => clearTimeout(handler);
    }, [debounceSearch]);

    return (
        <>
            <BookingDataProvider>
                <CustomHeader
                    leftItems={['logo']}
                    logo={organizer?.logo}
                    companyName={organizer?.companyName}
                    centerItems={isOrgId ? ['search'] : []}
                    rightItems={['login', 'signup', 'menuIcons']}
                    orgid={organizer?._id}
                    onSearch={setDebounceSearch}
                    searchValue={debounceSearch}
                    setDebounceSearch={setDebounceSearch}
                />
                <ScrollToTop />
                <Routes>
                    <Route path='trip/details/:id' element={<TripDetails />} />
                    <Route path='review-booking' element={<ReviewBooking />} />
                    <Route path='payment-verification' element={<VerifyPayment />} />
                    <Route path='booking-confirmation' element={<BookingConfirmation />} />
                    <Route path='orgid/:id' element={<OrganizerTrips />} />
                </Routes>
                <CustomFooter />
            </BookingDataProvider>
        </>
    );
}
